/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function redirectTo(params, context) {
    var _a;
    var api = 'dd.biz.navigation.replace';
    (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params);
}

export { redirectTo as default };
